import type {PageRouteConfig} from '@router';

import ServiceArea from 'modules/Services/ServiceArea/ServiceArea';

export function createServiceAreaRoute(): PageRouteConfig {
  return {
    element: <ServiceArea />,
    layout: {
      title: 'محدوده ارسال',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
